import {create} from 'zustand';
export const useUsersStore = create((set) => ({
    users: null,
    user: null,
    roleSchema: null,
    setUsers: (users) => set({ users }),
    setUser: (user) => set({ user }),
    setRoleSchema: (roleSchema) => set({ roleSchema }),
}));